import React from 'react';
import { mockData } from '../mock';

const About = () => {
  return (
    <section className="bg-black py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative group">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src={mockData.director.profileImage}
                alt="Director Rrammy"
                className="w-full h-auto filter grayscale contrast-110 brightness-95 hover:grayscale-0 transition-all duration-700 transform group-hover:scale-105"
              />
              {/* Golden Border Effect */}
              <div className="absolute inset-0 border-2 border-amber-400/0 group-hover:border-amber-400/50 transition-all duration-500 rounded-lg"></div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-amber-400/20 to-transparent rounded-full blur-3xl"></div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-5xl md:text-6xl font-bold mb-4">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
                  The Director
                </span>
              </h2>
              <div className="h-1 w-24 bg-gradient-to-r from-amber-400 to-transparent mb-8"></div>
            </div>

            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p className="text-lg">
                {mockData.director.bio}
              </p>
              <p className="text-lg">
                His work spans across <span className="text-amber-400 font-semibold">commercial advertising</span>, <span className="text-amber-400 font-semibold">digital campaigns</span>, and <span className="text-amber-400 font-semibold">narrative cinema</span>, with notable award-winning short films including <em>Una</em>, <em>Rinti</em>, and <em>The Unknown Codes</em>.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8">
              <div className="border-l-2 border-amber-400 pl-6">
                <div className="text-4xl font-bold text-amber-400">500+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider mt-2">Commercials</div>
              </div>
              <div className="border-l-2 border-amber-400 pl-6">
                <div className="text-4xl font-bold text-amber-400">Multiple</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider mt-2">Awards</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;